import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-text.svg'
import _imports_1 from '@/assets/img/icons-img/file-add.svg'
import _imports_2 from '@/assets/img/icons-img/folder-drive.svg'
import _imports_3 from '@/assets/img/icons-img/question.svg'
import _imports_4 from '@/assets/img/graphic/bg-desktop-graphic.svg'
import _imports_5 from '@/assets/img/logo-text-inverse.svg'
import _imports_6 from '@/assets/img/icons-img/users.svg'
import _imports_7 from '@/assets/img/icons-img/user-add.svg'
import _imports_8 from '@/assets/img/icons-img/settings.svg'


const _withScopeId = n => (_pushScopeId("data-v-9ba0d5ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "logo--mobile",
  src: _imports_0,
  alt: "logo"
}
const _hoisted_3 = {
  key: 1,
  class: "df mt-15"
}
const _hoisted_4 = { class: "mr-8 w-100" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-bell" }, null, -1))
const _hoisted_6 = { class: "badge-wrapper" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "start-tooltip" }
const _hoisted_9 = { class: "login" }
const _hoisted_10 = {
  key: 3,
  class: "text--footer"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Want to know more about Case Drive? ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://www.casedrive.co/" }, "Tap here", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" to get your questions answered.")
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 4,
  class: "mt-16",
  ref: "scrollItem"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 1,
  class: "desktop--container"
}
const _hoisted_18 = { class: "desktop--header" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_20 = {
  class: "desktop--header--nav",
  "desktop--header--divider": ""
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Create Account")
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Log In")
const _hoisted_25 = { key: 2 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0);" }, "Log Out", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "desktop--body" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "desktop--logo",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--case" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--icon" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "icon iconn--file-add",
        src: _imports_1,
        alt: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "desktop--case--title" }, "New Case1")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--icon" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "icon iconn--drive",
        src: _imports_2,
        alt: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "desktop--case--title" }, "Drive")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--icon" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "icon iconn--question",
        src: _imports_3,
        alt: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "desktop--case--title" }, "Need Help?")
  ])
], -1))
const _hoisted_31 = {
  key: 2,
  class: "desktop--container desktop--container--primary"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg-graphic",
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_33 = { class: "desktop--header" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "desktop--logo",
  src: _imports_5,
  alt: "logo"
}, null, -1))
const _hoisted_35 = { class: "desktop--header--nav" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("ul", { class: "list-icon" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0);" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "icon icon-bell disabled" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "/messages/my" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "icon icon-chat" })
      ])
    ])
  ])
], -1))
const _hoisted_37 = { class: "user--box" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "el-dropdown-link" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-caret" }, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Action 1")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Action 2")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Action 3")
const _hoisted_44 = { class: "desktop--body" }
const _hoisted_45 = { class: "desktop--case desktop--case--lg desktop--case--inverse" }
const _hoisted_46 = { class: "row-case" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon iconn--file-add",
      src: _imports_1,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "desktop--case--title" }, "New Case")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon iconn--drive",
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "desktop--case--title" }, "Drive", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon iconn--spaces",
      src: _imports_6,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "desktop--case--title" }, "Spaces")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon iconn--invite",
      src: _imports_7,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "desktop--case--title" }, "Invite People")
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon iconn--invite",
      src: _imports_8,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "desktop--case--title" }, "Invite People")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desktop--case--icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon iconn--question",
      src: _imports_3,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "desktop--case--title" }, "Need Help?")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_badge = _resolveComponent("app-badge")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_clue_tooltip = _resolveComponent("app-clue-tooltip")!
  const _component_cases_items = _resolveComponent("cases-items")!
  const _component_login_registration_link = _resolveComponent("login-registration-link")!
  const _component_app_upload_controls = _resolveComponent("app-upload-controls")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_container, {
          direction: "vertical",
          "data-component": "welcome"
        }, {
          default: _withCtx(() => [
            (_ctx.isDataLoading)
              ? (_openBlock(), _createBlock(_component_app_loader, {
                  key: 0,
                  message: "Creating your first Case!..."
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_app_header, null, {
              bottom: _withCtx(() => [
                (!_ctx.isAuth)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_app_search, {
                          modelValue: _ctx.searchValue,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
                          onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchValue = '')),
                          onInput: _ctx.navigateToDrive
                        }, null, 8, ["modelValue", "onInput"])
                      ]),
                      (_ctx.isAuth)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "circle mr-8 white-icon",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo('/alerts')))
                          }, [
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_app_badge, {
                                number: _ctx.mainStore.badgesAlert
                              }, null, 8, ["number"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isAuth)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "circle mr-8",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo('/profile')))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.photoUrl,
                              alt: "profile photo"
                            }, null, 8, _hoisted_7)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.mainStore.user.showTutorial)
                ? (_openBlock(), _createBlock(_component_app_clue_tooltip, {
                    key: 0,
                    onScrollDown: _ctx.scrollToBottom
                  }, null, 8, ["onScrollDown"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isAuth)
              ? (_openBlock(), _createBlock(_component_cases_items, {
                  key: 1,
                  title: _ctx.$localize('welcome.latest.cases'),
                  onViewAll: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateTo('/drive/my/cases'))),
                  class: "mt-16",
                  cases: _ctx.driveStore.cases.data,
                  lastPage: _ctx.driveStore.cases.lastPage,
                  skeleton: _ctx.driveStore.dataLoading.cases,
                  "show-create-case-btn": !_ctx.driveStore.cases.data.length
                }, null, 8, ["title", "cases", "lastPage", "skeleton", "show-create-case-btn"]))
              : _createCommentVNode("", true),
            (_ctx.isAuth)
              ? (_openBlock(), _createBlock(_component_cases_items, {
                  key: 2,
                  title: _ctx.$localize('welcome.latest.cases.network'),
                  onViewAll: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateTo('/drive/network/cases'))),
                  class: "cases-network",
                  cases: _ctx.driveStore.networkCases.data,
                  lastPage: _ctx.driveStore.networkCases.lastPage,
                  skeleton: _ctx.driveStore.dataLoading.networkCases,
                  isNetwork: ""
                }, null, 8, ["title", "cases", "lastPage", "skeleton"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              (!_ctx.isAuth)
                ? (_openBlock(), _createBlock(_component_login_registration_link, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.isAuth)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _hoisted_14))
              : _createCommentVNode("", true),
            (_ctx.isAuth)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_app_upload_controls)
                ], 512))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            (_ctx.isDataLoading)
              ? (_openBlock(), _createBlock(_component_app_loader, {
                  key: 0,
                  message: "Creating your first Case!..."
                }))
              : _createCommentVNode("", true),
            (!_ctx.isAuth)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("ul", _hoisted_20, [
                      (!_ctx.isAuth)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                            _createVNode(_component_router_link, { to: "/registration" }, {
                              default: _withCtx(() => [
                                _hoisted_22
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.isAuth)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                            _createVNode(_component_router_link, { to: "/login" }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isAuth)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_25, _hoisted_27))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_app_search, {
                      modelValue: _ctx.searchValue,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchValue) = $event)),
                      onClear: _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchValue = '')),
                      onInput: _ctx.navigateToDrive
                    }, null, 8, ["modelValue", "onInput"]),
                    _hoisted_30
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAuth)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("ul", _hoisted_35, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_app_search, {
                          modelValue: _ctx.searchValue,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchValue) = $event)),
                          onClear: _cache[9] || (_cache[9] = ($event: any) => (_ctx.searchValue = '')),
                          onInput: _ctx.navigateToDrive
                        }, null, 8, ["modelValue", "onInput"])
                      ]),
                      _hoisted_36,
                      _createElementVNode("li", null, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("img", {
                            class: "user--ava",
                            src: _ctx.photoUrl,
                            alt: ""
                          }, null, 8, _hoisted_38),
                          _createVNode(_component_el_dropdown, null, {
                            dropdown: _withCtx(() => [
                              _createVNode(_component_el_dropdown_menu, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_dropdown_item, null, {
                                    default: _withCtx(() => [
                                      _hoisted_41
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_dropdown_item, null, {
                                    default: _withCtx(() => [
                                      _hoisted_42
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                                    default: _withCtx(() => [
                                      _hoisted_43
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_dropdown_item, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args))),
                                        class: "logout-btn"
                                      }, " Log Out ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_39, [
                                _createTextVNode(_toDisplayString(_ctx.fullName) + " ", 1),
                                _hoisted_40
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createVNode(_component_router_link, {
                          to: "/drive",
                          class: "desktop--case--item"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_48,
                            _hoisted_49
                          ]),
                          _: 1
                        }),
                        _hoisted_50,
                        _hoisted_51,
                        _hoisted_52,
                        _hoisted_53
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
}